import React, { useEffect, useState } from "react";
import { Play, Loader2, Clapperboard } from "lucide-react";
import { toast } from "sonner";
import { memberApi, imgUrl, mediaUrl, getMemberToken, fmtDuration, errMsg } from "../lib/api";
import { Dialog, DialogContent, DialogTitle } from "../components/ui/dialog";

export default function VideosSection() {
  const [videos, setVideos] = useState(null);
  const [playing, setPlaying] = useState(null);
  useEffect(() => {
    memberApi.get("/member/videos").then((r) => setVideos(r.data)).catch((e) => { toast.error(errMsg(e, "Could not load videos")); setVideos([]); });
  }, []);

  const play = (v) => {
    setPlaying(v);
    memberApi.post(`/member/videos/${v.id}/view`).catch(() => {});
  };

  return (
    <section className="mb-10" data-testid="foryou-videos">
      <h2 className="mem-brand text-[24px] flex items-center gap-2 mb-4"><Clapperboard className="w-6 h-6 text-[#e8365f]" /> Videos for you</h2>
      {!videos ? <div className="py-10 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-[#e8365f]" /></div> : !videos.length ? (
        <div className="mem-card p-6 text-center text-[14px] text-[#6b5d60]" data-testid="videos-empty">No videos yet... something's coming soon.</div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-5" data-testid="mem-videos-grid">
          {videos.map((v) => (
            <button key={v.id} onClick={() => play(v)} className="mem-card overflow-hidden text-left group" data-testid={`mem-video-${v.id}`}>
              <div className="relative aspect-video bg-[#2a1f22] overflow-hidden">
                {v.thumbnail_url && <img src={imgUrl(v.thumbnail_url)} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />}
                <span className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <span className="absolute inset-0 grid place-items-center">
                  <span className="w-14 h-14 rounded-full bg-white/90 grid place-items-center shadow-lg group-hover:scale-110 transition-transform"><Play className="w-6 h-6 text-[#e8365f] ml-1" fill="currentColor" /></span>
                </span>
                {v.duration && <span className="absolute bottom-3 right-3 text-[12px] text-white bg-black/60 rounded px-2 py-0.5">{fmtDuration(v.duration)}</span>}
                <span className="absolute top-3 left-3 text-[11px] font-semibold text-white bg-[#e8365f] rounded-full px-2.5 py-0.5">VIP</span>
              </div>
              <div className="p-4">
                <p className="text-[17px] font-semibold">{v.title}</p>
                {v.description && <p className="text-[14px] text-[#5a4c4f] mt-1 line-clamp-2">{v.description}</p>}
                <p className="text-[12px] text-[#9a8b8e] mt-2">{new Date(v.created_at).toLocaleDateString([], { day: "numeric", month: "short" })}</p>
              </div>
            </button>
          ))}
        </div>
      )}

      <Dialog open={!!playing} onOpenChange={(o) => !o && setPlaying(null)}>
        <DialogContent className="max-w-[900px] p-0 overflow-hidden bg-black border-0">
          <DialogTitle className="sr-only">{playing?.title}</DialogTitle>
          {playing && (
            <div>
              <video src={mediaUrl(playing.url, getMemberToken())} controls autoPlay playsInline controlsList="nodownload"
                onContextMenu={(e) => e.preventDefault()} className="w-full max-h-[78vh] bg-black" data-testid="mem-video-player" />
              <div className="px-5 py-3 text-white"><p className="font-semibold">{playing.title}</p>{playing.description && <p className="text-[13px] text-white/70">{playing.description}</p>}</div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
